import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSignalService } from '../state/auth.signal';

/**
 * Guard de ruta por permiso. Permite el acceso si el usuario tiene AL MENOS UNO
 * de los permisos indicados; si no, lo devuelve a la bandeja. El SUPERADMIN siempre pasa.
 *
 *   canActivate: [permissionGuard('users.view')]
 *   canActivate: [permissionGuard('campaigns.view')]
 */
export function permissionGuard(...perms: string[]): CanActivateFn {
  return () => {
    const auth = inject(AuthSignalService);
    const router = inject(Router);
    if (perms.length === 0 || auth.hasAny(...perms)) return true;
    return router.createUrlTree(['/inbox']);
  };
}
